import { AppRouteProps } from "@bsm/component";
import React from "react";
const ProjectDayOffViewsSummaryContainer = React.lazy(
    () => import("./container/ProjectDayOffViewsSummaryContainer")
);

export const ProjectDayOffViewsSummaryRoutes: Array<AppRouteProps> = [
    {
        path: "summary",
        title: "BSMRH.Vacation.DayOff.Summary",
        element: <ProjectDayOffViewsSummaryContainer />,
        roles: ["TIMEOFF"],
    },
];
